export default {
    translations: '多语言',
    logOut: '退出登陆',
    login: {
        playground: '试用看看',
        login: '登录',
        signup: '注册',
        account: '账号',
        password: '密码',
        verifyCode: '发送验证码',
        weChat: '微信',
        qq: 'QQ'
    }
}



// WEBPACK FOOTER //
// ./src/language/zh.js